import { get, startsWith, endsWith, trimEnd } from 'lodash'

import { routes } from '@/features/routes'

const isMatchPathnamePattern = (pattern: string) => {
  let currentPath = window.location.pathname

  const patternArr = pattern.split('/')

  if (endsWith(currentPath, '/')) {
    currentPath = trimEnd(currentPath, '/')
  }

  const currentPathArr = currentPath.split('/')

  if (patternArr.length !== currentPathArr.length) return false

  let isMatch = true

  for (let i = 0; i < patternArr.length; i += 1) {
    if (startsWith(patternArr[i], '[')) continue

    if (patternArr[i] !== currentPathArr[i]) {
      isMatch = false
      break
    }
  }

  return isMatch
}

const getRouteName = () => {
  const routeObj = routes.find((r) => {
    return isMatchPathnamePattern(r.pattern)
  })

  return get(routeObj, 'name')
}

const getRoutePattern = () => {
  const routeObj = routes.find((r) => {
    return isMatchPathnamePattern(r.pattern)
  })

  return get(routeObj, 'pattern')
}

export const useActiveRoute = () => {
  return function (targetRoutes: string[] = []) {
    const routeName = getRouteName()
    const pathname = window.location.pathname

    return (
      (routeName && targetRoutes.includes(routeName)) ||
      targetRoutes.some((r) => pathname.includes(r))
    )
  }
}

export const getPathParams = () => {
  const pathname = window.location.pathname
  const result = {}

  const pattern = getRoutePattern()

  if (!pattern) return result

  const pathnameArr = pathname.split('/')
  const patternArr = pattern.split('/')

  for (let i = 0; i < pathnameArr.length; i += 1) {
    const section = patternArr[i]

    if (startsWith(section, '[')) {
      result[section.substring(1, section.length - 1)] = pathnameArr[i]
    }
  }

  return result
}
